/** 0 is A */
export function numberToLetters(num, alphabet) {
    let letters = "";
    while (num >= 0) {
        letters = alphabet[num % alphabet.length] + letters;
        num = Math.floor(num / alphabet.length) - 1;
    }
    return letters;
}
export function parseAlphabet(alphabet) {
    return alphabet === "numeric" ? undefined : alphabet?.split(" ");
}
export function replaceAutoWithDefault2(vector, defaultVal) {
    return {
        x: !vector || vector.autoX ? defaultVal.x : vector.x,
        y: !vector || vector.autoY ? defaultVal.y : vector.y,
    };
}
export function replaceAutoWithDefault3(vector, defaultVal) {
    return {
        x: !vector || vector.autoX ? defaultVal.x : vector.x,
        y: !vector || vector.autoY ? defaultVal.y : vector.y,
        z: !vector || vector.autoZ ? defaultVal.z : vector.z,
    };
}
//# sourceMappingURL=utils.js.map